<template>
  <div class="margin-top">
    <el-card
      v-for="(item, index) in messageList"
      :key="index"
      class="padding-sm margin-lr-sm margin-top-sm"
    >
      <el-col :span="6">
        <img :src="item.filePath" style="width: 240px" />
      </el-col>
      <el-col :span="17" class="margin-left-sm">
        <p
          class="text-bold margin-bottom-sm"
          style="line-height: 0px"
          @click="onDetail(item)"
        >
          {{ item.title }}
        </p>
        <p class="text-sm">
          <i class="el-icon-time"></i><span> {{ item.updateTime }}</span
          ><i class="el-icon-user margin-left-sm"></i
          ><span> {{ item.author }}</span>
        </p>
        <p class="text-df" style="color: #606266" @click="onDetail(item)">
          {{ item.shortDescription }}
          <span class="cursor primary">详情>></span>
        </p>
      </el-col>
    </el-card>

    <span
      class="more cursor fr margin-top-sm text-df margin-right-xs text-grey"
      @click="onMore(type)"
      >查看更多
      <img
        src="@/assets/icon-more.png"
        style="width: 20px; vertical-align: bottom"
        alt=""
    /></span>
  </div>
</template>
<script>
import api from "@/utils/api";
export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      messageList: [],
      apiList: [
        {
          key: "researchReport", //产业研究报告
          apiName: "getResearchReportApi",
          idName: "researchId",
          type: 1,
        },
        {
          key: "notice",
          apiName: "getNoticeApi",
          idName: "noticeId",
          type: null,
        },
        {
          key: "news",
          apiName: "getNewsApi",
          idName: "newsId",
          type: null,
        },
        {
          key: "memberCenter",
          apiName: "getVipApi",
          idName: "vipId",
          type: null,
        },
        {
          key: "industry",
          apiName: "getPropertyApi",
          idName: "propertyId",
          type: null,
        },
      ],
    };
  },
  watch: {
    type: {
      handler(val) {
        this.getData();
      },
      immediate: true,
    },
  },
  methods: {
    switchUrl() {
      let url =
        this.type == 0
          ? "/information/notice"
          : this.type == 1
          ? "/information/news"
          : this.type == 2
          ? "/information/memberCenter"
          : "/information/industry";
      return url;
    },
    switchApi() {
      let api =
        this.type == 0
          ? "getNoticeApi"
          : this.type == 1
          ? "getNewsApi"
          : this.type == 2
          ? "getVipApi"
          : "getPropertyApi";
      return api;
    },
    switchIdName() {
      let api =
        this.type == 0
          ? "noticeId"
          : this.type == 1
          ? "newsId"
          : this.type == 2
          ? "vipId"
          : "propertyId";
      return api;
    },
    onMore() {
      let url = this.switchUrl();
      this.$router.push({
        path: url,
      });
    },
    onDetail(val) {
      let id = val[this.switchIdName()];
      let url = this.switchUrl();
      let name = url.split("/")[2];
      this.$router.push({
        path: "/information/detail",
        query: {
          name,
          id,
        },
      });
    },
    async getData() {
      let apiName = await this.switchApi();
      let res = await api[apiName]({ pageNum: 1, pageSize: 2 });
      if (res.code == 200) {
        this.messageList = res.data.list;
      }
    },
  },
};
</script>
<style scoped>
.el-card__header {
  padding: 0px;
  border-bottom: none;
}
</style>